export function flatMap<T, U>(
  array: T[],
  callbackfn: (value: T, index: number, array: T[]) => U[],
): U[] {
  return Array.prototype.concat(...array.map(callbackfn));
}



// WEBPACK FOOTER //
// ./app/gamma/src/util/flat-map.ts